import React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toggleSidebar } from '../../store/actions/layout';

const Support = () => {
   const dispatch = useDispatch();
   const { isAuthenticated } = useSelector((state) => state.auth);
   const { isSidebarOpened } = useSelector((state) => state.layout);
   useEffect(() => {
      window.scrollTo(0, 0);
   }, []);
   return (
      <main className='support' onClick={() => isSidebarOpened && dispatch(toggleSidebar())}>
         <div className='support__slider'></div>
         <div className='support__content'>
            <h1 className='support__content-title'>راه های ارتباط با پشتیبانی</h1>
            <ul className='box box-support'>
               <li className='support__content-item'>
                  <img
                     src='./img/email.svg'
                     alt=''
                     className='support__content-icon'
                     title='ایمیل پشتیبانی'
                  />
                  <p className='support__content-text'>kalapost.co@gmail.com</p>
               </li>
               <li className='support__content-item'>
                  <img
                     src='./img/phone.svg'
                     alt=''
                     className='support__content-icon'
                     title='شماره تماس پشتیبانی'
                  />
                  <p className='support__content-text'>09123456789</p>
               </li>
               <li className='support__content-item'>
                  <img
                     src='./img/support-telegram.svg'
                     alt=''
                     className='support__content-icon'
                     title='تلگرام پشتیبانی'
                  />
                  <p className='support__content-text'>@kalapostSupport</p>
               </li>
               <li className='support__content-item'>
                  <img
                     src='./img/support-whatsapp.svg'
                     alt=''
                     className='support__content-icon'
                     title='واتساپ پشتیبانی'
                  />
                  <p className='support__content-text'>09123456789</p>
               </li>
            </ul>
         </div>
         <Link to='/order' className='main__Send-package'>
            <img className='main__Send-package-img' src='./img/postfix.png' alt='' />
            <h4>ارسال بسته</h4>
         </Link>
      </main>
   );
};

export default Support;
